// extracted by mini-css-extract-plugin
export var activityContainer = "_gb-0";
export var typingIndicatorContainer = "_gb-1";
export var typingIndicatorDot = "_gb-2";
export var wave = "_gb-3";